import type { FaireProductEntity } from "../../entity_types/product";

export const p_fd974g2j5h: FaireProductEntity = {
  token: "p_fd974g2j5h",
  type: "product",
  name: "I ❤️ Peanut Butter Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/25d7847f46ace57cc77b7f5492c80cc7d393dd505a67f26dd181e7b1f61a7d40.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95f9ebeb834fd0321d84a8441675eeca86d37271bfb170c075fcb71e998be32f.jpeg",
    "https://cdn.faire.com/fastly/9d42711b84ed7f2ad602dc83e63d4a1d326ad8408a9ce808f37cd5748945c6e6.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/f7f770a1c75749d318d59ebdbf330263fa7a04a62f26ab61e27662f51a078fd2.jpeg",
    "https://cdn.faire.com/fastly/688350a4b660a3cb3e25e973d4200b6545af37fd940e4cd9b1a332de48433f83.jpeg"
  ],
  priceDollars: 6.75,
  description: "Wear these socks with pride, and maybe a spoon in hand. Smooth, crunchy, or straight from the jar, your ❤️ belongs to the one and only. Not only are they comfy, but they'll say what you're not able to say (because your mouth is full of peanut butter).\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:25.699Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
